import { render, staticRenderFns } from "./ListaReservasView.vue?vue&type=template&id=24029b16&"
import script from "./ListaReservasView.vue?vue&type=script&lang=ts&"
export * from "./ListaReservasView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports